var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 1.99808C5.2386 1.99805 3 4.23662 3 6.99805C3 9.75947 5.23859 11.998 8.00002 11.998C10.7614 11.998 13 9.75949 13 6.99808C13 4.23668 10.7614 1.99811 8.00002 1.99808Z",
    stroke: "#B8B8B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.60596,
    y: 9.99805,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(40.7555 4.60596 9.99805)",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.03f489f4dc72cad4c43ba60dda1e373f.svg";
export { ForwardRef as ReactComponent };